import { useMemo } from 'react';
/**
 * 用于V2table的V2dragList 配置读写函数
 * @param { Array<any> } confColumns 动态配置表
 * @param { Array<any> } defaultColumns 默认配置表
 * @return { Array<any> } 实际导出的配置表
 * @example
 *  const columns = useColumns(confColumns, defaultColumns);
**/
function useColumns(confColumns, defaultColumns) {
  return useMemo(() => {
    const newColumns = confColumns.length ? [] : defaultColumns.map(item => {
      return {
        ...item
      }
    });
    confColumns.forEach((item => {
      const target = defaultColumns[item.originIndex];
      if (target.key === item.key) {
        if (item.dragChecked) {
        newColumns.push({
          ...item,
          ...target,
            dragChecked: item.dragChecked,
            dragDisabled: item.dragDisabled || target.dragDisabled,
        });
        }
      } else {
        const _item = defaultColumns.find(item2 => (item2.key === item.key));
        if (_item && item.dragChecked) {
          newColumns.push({
            ...item,
            ..._item,
            dragChecked: item.dragChecked,
            dragDisabled: item.dragDisabled || _item.dragDisabled,
          })
        }
      }
    }));
    return newColumns;
  }, [confColumns]);
}
export default useColumns;
